/* Natural image coordinates for the supplier UploadData contract. */
(() => {
  'use strict';
  const rotatedSize = (width, height, rotate = 0) => {
    if (![width, height, rotate].every(Number.isFinite) || width <= 0 || height <= 0 || Math.abs(rotate) > 360) throw new Error('Invalid rotation geometry');
    const radians = rotate * Math.PI / 180;
    const cosine = Math.abs(Math.cos(radians)), sine = Math.abs(Math.sin(radians));
    return {width: width * cosine + height * sine, height: width * sine + height * cosine};
  };
  const cropRect = (width, height, aspect, zoom = 1, centerX = .5, centerY = .5, rotate = 0) => {
    if (![width, height, aspect, zoom, centerX, centerY].every(Number.isFinite) || width <= 0 || height <= 0 || aspect <= 0 || zoom < 1 || zoom > 8) throw new Error('Invalid crop geometry');
    const bounds = rotatedSize(width, height, rotate);
    width = bounds.width; height = bounds.height;
    const baseWidth = Math.min(width, height * aspect);
    const cropWidth = baseWidth / zoom;
    const cropHeight = cropWidth / aspect;
    const x = Math.max(0, Math.min(width - cropWidth, width * centerX - cropWidth / 2));
    const y = Math.max(0, Math.min(height - cropHeight, height * centerY - cropHeight / 2));
    return {x, y, width: cropWidth, height: cropHeight, rotate, aspect};
  };
  const serialize = crop => {
    if (![crop.x, crop.y, crop.width, crop.height, crop.rotate, crop.aspect].every(Number.isFinite) || crop.x < 0 || crop.y < 0 || crop.width <= 0 || crop.height <= 0 || crop.aspect <= 0 || Math.abs(crop.rotate) > 360) throw new Error('Invalid supplier crop');
    return `x:${Math.round(crop.x)},y:${Math.round(crop.y)},w:${Math.round(crop.width)},h:${Math.round(crop.height)},r:${crop.rotate},ar:${crop.aspect}`;
  };
  const api = {cropRect, rotatedSize, serialize};
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  else window.CJPhotoCrop = api;
})();
